import { useState } from "react";
import { Col, Row } from "react-bootstrap";
import ReactGA from "react-ga4";
import { useForm } from "react-hook-form";
import { Link } from "react-router-dom";
import { useLoginMutation } from "../../../redux/api/auth/authAPI";
import AuthDTO from "../../../shared/oversight-core/dtos/request-dtos/auth-dto";
import { AppRoute } from "../../../shared/oversight-core/interfaces/app-routes";
import { IHttpError } from "../../../shared/oversight-core/interfaces/http-errror";
import AppButton from "../../../shared/oversight-core/ui-elements/buttons/app-button/app-button";
import AppInput from "../../../shared/oversight-core/ui-elements/input/app-input";
import { showErrorMessage } from "../../../shared/oversight-core/utils/toast";

const LoginForm = () => {
  const [showPassword, setShowPassword] = useState(false);
  const [login, { isError, isLoading }] = useLoginMutation();

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<AuthDTO>();

  const onSubmit = (data: AuthDTO) => {
    login({
      ...data,
      rememberMe: false,
      serviceProvider: "CEB",
    })
      .unwrap()
      .then(() => {
        ReactGA.event({
          category: "Successful",
          action: "Login",
        });
      })
      .catch((error: IHttpError) => {
        showErrorMessage(error.message || "Something went wrong");
      });
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)} className="ui-stagger">
      <div className="mt-3 mt-sm-4 mt-md-5">
        <AppInput
          className="mt-3"
          name="username"
          leftIcon="mail"
          placeholder="Email"
          register={register("username", {
            required: "Email is required",
          })}
          errors={errors}
          isError={isError}
        />
        <AppInput
          className="mt-3"
          name="password"
          leftIcon="key"
          icon={!showPassword ? "visibility_off" : "visibility"}
          placeholder="Password"
          onIconClick={() => setShowPassword(!showPassword)}
          type={showPassword ? "text" : "password"}
          register={register("password", {
            required: "Password is required",
          })}
          errors={errors}
          isError={isError}
        />
      </div>
      <Row className="mt-3 mt-sm-4">
        <Col className="text-end">
          <Link to={AppRoute.FORGOT_PASSWORD} className="text-link">
            Forgot password
          </Link>
        </Col>
      </Row>
      <AppButton
        text="Sign in"
        className="mt-3 mt-sm-4 mt-md-5"
        variant="blue"
        isLoading={isLoading}
      />
      <Row className="justify-content-center mt-3">
        <Col className="text-center font-size-14 text-light">
          Don&apos;t have an account?&nbsp;
          <Link to={AppRoute.REGISTER} className="text-link">
            Sign Up
          </Link>
        </Col>
      </Row>
    </form>
  );
};

export default LoginForm;
